// removed by extract-text-webpack-plugin
module.exports = {"Card":"_36r9t_R-kB5oEZmqf4IHwH","Header":"_2X41huhpiubEJeycvSP6A-","Title":"_1yK-xXXPdSxuJrV8JMQiAv","Btn":"_2iVj78hRPKLUxnbRri_Zcd","IconLeft":"_3hYWA8-30cK_nPCdo_ayAR","PaginationWrap":"_2TomVDKBf89XPTe3d-LkJ9","ActiveLink":"_1xe1nLV_c6wl3-KvbGxxMo","Tabs":"m84pbCluZWHwUTW9QNiRe","Tab":"_3egKq7CtYkw3W6nRWio-FU","TabActive":"_3Mgcb1xs1YMHkTU9-k1zHE","TabsBar":"VhQjGcvCWIjM2GUBHwNLQ","TabPane":"_1-94QgXx169e7CuFQ8ION3","HintBox":"_1lf6Brc8AFftWAZAlNQepm"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/Terminals/styles.module.css
// module id = 204
// module chunks = 0